/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grab thumbnails in every size`)
};

const es_yt_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtén miniaturas en todos los tamaños`)
};

const de_yt_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thumbnails in jeder Größe abrufen`)
};

const nl_yt_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thumbnails in elk formaat`)
};

const fr_yt_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récupérez les miniatures dans toutes les tailles`)
};

const it_yt_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottieni le miniature in ogni dimensione`)
};

const pt_br2_yt_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pegue thumbnails em todos os tamanhos`)
};

const pt_yt_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenha miniaturas em todos os tamanhos`)
};

const ja_yt_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あらゆるサイズのサムネイルを取得`)
};

const zh_yt_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`获取所有尺寸的缩略图`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_nav_main_desc", locale)
	if (locale === "en") return en_yt_nav_main_desc(inputs)
	if (locale === "es") return es_yt_nav_main_desc(inputs)
	if (locale === "de") return de_yt_nav_main_desc(inputs)
	if (locale === "nl") return nl_yt_nav_main_desc(inputs)
	if (locale === "fr") return fr_yt_nav_main_desc(inputs)
	if (locale === "it") return it_yt_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_yt_nav_main_desc(inputs)
	if (locale === "pt") return pt_yt_nav_main_desc(inputs)
	if (locale === "ja") return ja_yt_nav_main_desc(inputs)
	return zh_yt_nav_main_desc(inputs)
};